import { render, staticRenderFns } from "./RecordSituationsSetting.vue?vue&type=template&id=237bcee0"
import script from "./RecordSituationsSetting.vue?vue&type=script&lang=js"
export * from "./RecordSituationsSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports